import { useEffect, useState } from "react";
import { Call, useStreamVideoClient } from "@stream-io/video-react-sdk";
import Toast from "../components/Sweetalert/Sweetalert";

export const useGetCallById = (id: string | string[]) => {
  const [call, setCall] = useState<Call>();
  const [isCallLoading, setIsCallLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  const client = useStreamVideoClient();

  useEffect(() => {
    if (!client) return;
    const loadCall = async () => {
      try {
        const { calls } = await client?.queryCalls({
          filter_conditions: { id },
        });
        if (calls.length > 0) setCall(calls[0]);
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setIsCallLoading(false);
      }
    };

    loadCall();
  }, [client, id]);

  if (!call) {
    // Toast.fire({
    //   text: "Call not initialized",
    //   icon: "error",
    // });
    // window.location.reload();
  }

  return { call, isCallLoading, error };
};
